export enum Breakpoints {
  XS = 480,
  SM = 768,
  MD = 992,
  LG = 1200
}
